import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ConsultationRoadmap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const steps = [{
    text: "Browse our catalog of premium SaaS tools, global eSIMs, and secure VPS solutions."
  }, {
    text: "Select your desired service and proceed to our streamlined, privacy-focused checkout."
  }, {
    text: "Generate a unique payment address for your chosen cryptocurrency (over 50+ coins supported)."
  }, {
    text: <>
          Complete the transaction using <span className="font-bold text-foreground">USDT, BTC, or ETH</span>. Our{" "}
          <span className="font-bold text-foreground">automated gateway</span> ensures your order is processed in real-time.
        </>
  }, {
    text: <span className="font-bold text-foreground">
          Your access credentials will be delivered via{" "}
          <Link to="#" className="text-primary underline decoration-primary underline-offset-4 hover:text-primary/80 transition-colors">
            our secure instant delivery system
          </Link>
          {" "}immediately after blockchain confirmation.
        </span>
  }];
  return <section data-section-id="65362" id="the-access-protocol" className="w-full bg-background py-20 text-foreground dark border-t border-b border-border">
      <div ref={ref} className={cn("mx-auto max-w-3xl px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        {}
        <h2 className="mb-12 text-4xl font-default font-bold leading-tight text-primary md:text-5xl tracking-tighter">
          The Access Protocol
        </h2>

        {}
        <div className="space-y-12">
          {steps.map((step, i) => <div key={i} data-index={i} className="group flex flex-col gap-4 md:flex-row md:items-start md:gap-8">
              {}
              <div className="shrink-0 select-none text-6xl font-mono font-bold leading-none tracking-tighter md:text-7xl opacity-50" style={{
            WebkitTextStroke: "1.5px var(--color-primary)",
            color: "transparent"
          }} aria-hidden="true">
                {i + 1}
              </div>

              {}
              <div className="pt-2 text-xl font-sans leading-relaxed md:text-2xl text-muted-foreground">
                <p>{step.text}</p>
              </div>
            </div>)}
        </div>

        {}
        <hr className="my-12 border-border" />

        {}
        <p className="text-lg font-sans text-muted-foreground">
          *Transactions are processed on-chain. Please ensure you include the network fee to cover the exact amount for instant automated delivery.
        </p>
      </div>
    </section>;
}